module.exports = __webpack_public_path__ + "img/No-Go-Away.7cb60955.jpg";